export const OverlayLocales = require("../data/locales/overlay.json");
export const SettingsLocales = require("../data/locales/settings.json");
